export const FilterDeviceGroupsState = {
  Assigned: 'assigned',
  NotAssigned: 'notAssigned'
} as const;

export type FilterDeviceGroupsState = (typeof FilterDeviceGroupsState)[keyof typeof FilterDeviceGroupsState] | null;

export const DEVICE_TYPES = ['reader', 'controller', 'handle', 'swingHandle', 'cylinder', 'locker'] as const;

export type DeviceType = (typeof DEVICE_TYPES)[number];

export type FilterDeviceTypeState = Record<DeviceType, boolean>;

export interface FilterBatteryStatusState {
  unknown: boolean;
  empty: boolean;
  critical: boolean;
  low: boolean;
  full: boolean;
}

export const FilterOfficeModeState = {
  HasOfficeMode: 'hasOfficeMode',
  NoOfficeMode: 'noOfficeMode'
} as const;

export type FilterOfficeModeState = (typeof FilterOfficeModeState)[keyof typeof FilterOfficeModeState] | null;

export type DevicesFilter = {
  filterDeviceGroups: FilterDeviceGroupsState;
  filterDeviceType: FilterDeviceTypeState;
  filterBatteryStatus: FilterBatteryStatusState;
  filterOfficeMode: FilterOfficeModeState;
};

export type DevicesFilterSetters = {
  setFilterDeviceGroups: (value: FilterDeviceGroupsState) => void;
  setFilterDeviceType: (
    value: FilterDeviceTypeState | ((current: FilterDeviceTypeState) => FilterDeviceTypeState)
  ) => void;
  setFilterBatteryStatus: (
    value: FilterBatteryStatusState | ((current: FilterBatteryStatusState) => FilterBatteryStatusState)
  ) => void;
  setFilterOfficeMode: (value: FilterOfficeModeState) => void;
};

export interface DevicesFilterState {
  filter: DevicesFilter;
  setters: DevicesFilterSetters;
  clearAllFilters: () => void;
  isAnyFilterEnabled: boolean;
}
